import { render, staticRenderFns } from "./new_trusteeship2.vue?vue&type=template&id=7903dc64&scoped=true&"
import script from "./new_trusteeship2.vue?vue&type=script&lang=js&"
export * from "./new_trusteeship2.vue?vue&type=script&lang=js&"
import style0 from "./new_trusteeship2.vue?vue&type=style&index=0&id=7903dc64&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7903dc64",
  null
  
)

export default component.exports